import React from "react";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

export default function SectionCard({
    section,
    isCollapsed,
    sectionCloseEnabled,
    setSectionRef,
    onToggleCollapsed,
    headerAction,
    children
}) {
    const hideTitle = section.id === "jutyusu" || section.id === "nouhinyotei";
    const sectionLabel = hideTitle
        ? ""
        : (section.id === "genka"
            ? (
                <span className="kakousiji-section-card__title kakousiji-section-card__title--genka">
                    <span className="kakousiji-section-card__title-bar"></span>
                    <span>{section.label}</span>
                </span>
            )
            : <span className="kakousiji-section-card__title">{section.label}</span>);

    return (
        <Box
            key={section.id}
            id={"kakou-section-" + section.id}
            ref={setSectionRef}
            className="kakousiji-section-card"
        >
            <Paper className="kakousiji-section-card__paper">
                <div className="kakousiji-section-card__header">
                    <span>{sectionLabel}</span>
                    <div className="kakousiji-section-card__actions">
                        {headerAction}
                        {sectionCloseEnabled ? (
                            <IconButton
                                type="button"
                                size="small"
                                title={isCollapsed ? "展開" : "折りたたみ"}
                                onClick={onToggleCollapsed}
                            >
                                <Icon>{isCollapsed ? "expand_more" : "expand_less"}</Icon>
                            </IconButton>
                        ) : null}
                    </div>
                </div>
                {isCollapsed ? null : children}
            </Paper>
        </Box>
    );
}
